export class AppConstants {
    //#region Route
    static ROUTES = class {
        public static readonly HOME = 'home';

        //#region MAIN
        public static readonly MAIN = "main";
        public static readonly SERVICE_INTRODUCTION = "service-introduction";
        //#endregion



        //#region Authentication
        public static readonly AUTHENTICATION = "authentication";
        public static readonly LOGIN = "login";
        public static readonly OTP_Page = "otp";
        public static readonly REGISTER = "register";
        public static readonly MY_ACCOUNT = "my-account";
        public static readonly MY_PROFILE = "my-profile";
        public static readonly FORGET_EMAIL = "forget-email";
        public static readonly CHANGE_PASS = "changePassword";
        public static readonly SUCCESS = "success";
        public static readonly RegisterVendor = "RegisterVendor";
        public static readonly Profile = "profile";
        public static readonly Messages = "Messages";
        public static readonly verifyEmail = "verify-email";
        //#endregion
        public static readonly VendorApplication = "VendorApplication";
        public static readonly BankAccount = "BankAccount";
        public static readonly email = "email";
        public static readonly FAQs = "faqs";

        //#region home


        //#endregion

        // Region Tender
        public static readonly TENDER = "tender";
        public static readonly TENDERDETAILS = "tenderdetails";
        // endregion


        //#region bid 
        public static readonly BID = "bid";
        public static readonly BIDDETAILS = "biddetails";
        //#endregion


        // #region financials
        public static readonly FINANCIALS = "financials";

        // #region RFP/RFQ
        public static readonly RFP_RFQ = "rfp-rfq";

        //#region Services
        public static readonly SERVICES = "services";
        public static readonly ALL = "all";
        public static readonly EMPTY = "empty";
        public static readonly REQUESTS = "requests"
        public static readonly REQUESTDETAILS = "requestdetails"
        //#endregion



        public static readonly PRIVACY_POLICY = "policy";
        public static readonly USIBILITY_CONDITIONS = "usibility-conditions";
        public static readonly SITE_MAP = "site-map";
        public static readonly CONTACT_US = "contact-us";
    }
    //#endregion

    //#region Controllers
    static CONTROLLERS = class {



        public static readonly ACCOUNT = 'Account';
        public static readonly REGISTER = 'Register';
        public static readonly VENDOR = 'vendor';
        public static readonly TENDERS = 'tenders';
        public static readonly BankAPI = 'BankAPI';
        public static readonly Lookups = 'Lookups';
        public static readonly notifications = 'notificaitons';
        public static readonly Messages = 'Messages';
        public static readonly Documents = 'Documents';
        public static readonly Common = 'Common';
        public static readonly FAQs = 'FAQs';



        public static readonly bids = 'bids';
        public static readonly PurchaseOrder = 'PurchaseOrder';

    }
    //#endregion

    //#region Actions
    static ACTIONS = class {
        //#region Account Controller


        public static readonly SendEmailTest = 'SendEmailTest';
        public static readonly GetAllVendors = 'GetAllVendors';
        public static readonly GetAllVendorsInfo = 'GetAllVendorsInfo';
        public static readonly ConfirmPO = 'ConfirmPO';
        public static readonly DeleteVendor = 'DeleteVendor';
        public static readonly MigrateVendorToERP = 'MigrateVendorToERP';
        public static readonly InviteVendor = 'InviteVendor';

        public static readonly GetTemplates = 'GetTemplates';
        public static readonly GetKeysByTemplate = 'GetKeysByTemplate';
        public static readonly UpdateEmailTemplate = 'UpdateEmailTemplate';
        public static readonly GetDocuments = 'GetDocuments';


        public static readonly AUTHENTICATE = 'Authenticate';
        public static readonly VerifyOTP = 'verify-otp';
        public static readonly Generateotp = 'generateotp';
        public static readonly SubmitTender = 'SubmitTender'
        public static readonly GetDashboardData = 'GetDashboardData'


        // Change-password via OTP/session (backend: POST /api/Account/change-password-with-otp)
        public static readonly CHANGEPASSOWRD = 'change-password-with-otp';
        // Change password while authenticated (current + new password; backend: POST /api/Account/changePassword)
        public static readonly CHANGE_PASSWORD = 'changePassword';
        public static readonly VerifyEmail = 'verifyemail';
        public static readonly VerifyEmailPassword = 'verify-email-Password';
        public static readonly REGISTERVENDOR = 'RegisterVendor';


        public static readonly GetPurchaseOrders = 'GetPurchaseOrders';
        public static readonly GetPayments = 'GetPayments';
        public static readonly GetGRNSPurchaseOrders = 'GetGRNSPurchaseOrders';
        public static readonly GetInvoicesPurchaseOrders = 'GetInvoicesPurchaseOrders';


        public static readonly GetBidDetails = 'GetBidDetails';

        public static readonly CheckEmailInUse = 'CheckEmailInUse';
        public static readonly ValidateVendorData = 'ValidateVendorData';

        public static readonly GetVendorByReferenceNo = 'GetVendorByReferenceNo';

        public static readonly UPDATEVENDOR = 'UPDATEVENDOR';

        public static readonly UploadDocumnets = 'UploadDocumnets';
        public static readonly UpdateDocuments = 'UpdateDocuments';

        public static readonly RemoveDocument = 'RemoveDocument';

        public static readonly GetBids = 'GetBids';

        public static readonly SubmitBid = 'SubmitBid';

        public static readonly UpdateOrCreateInvoice = 'UpdateOrCreateInvoice';

        public static readonly RequestGRN = 'RequestGRN';

        public static readonly GetGRNs = 'GetGRNSPurchaseOrders';

        public static readonly GetInvoices = 'GetInvoicesPurchaseOrders';







        public static readonly PREVIEW = '/api/documents/preview';















        public static readonly ACQUIRE_TOKEN = 'AcquireToken';
        public static readonly REFRESH_TOKEN = 'RefreshToken';
        public static readonly FAMILY = "family";
        public static readonly GetAccount = "GetAccount";
        public static readonly MEMBERS = "members";
        public static readonly NOMINEE = "Nominee";
        public static readonly REQUESTS = "requests";
        public static readonly REQUESTSDETAILSIN = "GetRequestById";
        public static readonly GetCountries = 'countries';
        public static readonly GetCurrencies = 'currencies';

        //#endregion

        //#region Request
        public static readonly SubmitLicencehouseBenfitRequestWithLoanForMarried = "SubmitLicencehouseBenfitRequestWithLoanForMarried";

        //#endregion

        //#region Banner
        public static readonly ALL = "All";
        public static readonly Get = "Get";

        //#region Vendor
        public static readonly GetProfile = 'GetProfile';
        public static readonly GetVendorDetails = 'GetVendorDetails';
        public static readonly UpdateVendorByID = "UpdateVendorByID";
        public static readonly UpdateVendor = "UpdateVendor";
        public static readonly UpdateVendorPassword = "UpdateVendorPassword";
        public static readonly CreateVendor = "CreateVendor";
        public static readonly ValidateContactEmail = "ValidateContactEmail";
        public static readonly ValidateContactMobile = "ValidateContactMobile";
        //#endregion

        //#region notificaitons
        public static readonly getNotifications = "GetNotifications";
        public static readonly deleteallnotifacitons = "ClearAllNotifications";
        public static readonly deleteanotifaciton = "ClearNotification";
        //#endregion

        //#region Tender
        public static readonly GetTenders = 'GetTenders';
        //#endregion

        //#region BankApi
        public static readonly GetBankAccounts = 'GetBankAccounts';
        public static readonly SubmitBankAccount = 'SubmitBankAccount';
        public static readonly UpdateBankDetailsByVendorID = 'UpdateBankDetailsByVendorID';
        //#endregion

        //#region Lookup

        //#endregion

        //#region AWARD
        public static readonly ROUTE = "Route";
        //#endregion

        //#region Training
        public static readonly PARTICIPATION = "Participation";
        public static readonly CANDIDATE = "Candidate";
        //#endregion

        //#region MARKETING_EXHIBITIONS
        //#endregion

        //#region Attachment
        public static readonly UPLOAD = "Upload";
        public static readonly TEMP = "Temp";
        public static readonly DELETE = "Delete";
        public static readonly DOWNLOAD = "Download";
        //#endregion
        //#region Integration
        public static readonly MOI = "MOI";
        public static readonly SAP = "SAP";
        public static readonly GET_NATIONAL_ADDRESS_BY_QID = "GetNationalAddressByQId";
        public static readonly GET_PERSONNEL_INFO_BY_QID_DETAILS = "GePersonnelInfobyQIdDetails"
        public static readonly GRSIA = "GRSIA";
        public static readonly GET_BENEFICIARY_DETAILS_BY_QID = "GetBeneficiaryDetailsByQId";
        public static readonly MOCI = "MOCI";
        public static readonly GET_BY_CR_NUMBER = "GetByCRNumber";
        public static readonly GET_EMP_DATA = "GetEmpData";
        public static readonly MSDF = "qnbn";
        public static readonly GET_SOCIAL_SECURITY = "GetSocialSecurity"

        public static readonly sendMessage = 'sendMessage';
        public static readonly GetMessages = 'GetMessages';

        //#region FAQs
        public static readonly GetAllFAQs = 'GetAllFAQs';
        public static readonly GetFAQById = 'GetFAQById';
        public static readonly GetPublishedFAQs = 'GetPublishedFAQs';
        //#endregion

        //#endregion
    }
    //#endregion

    //#region CLAIMS
    static CLAIMS = class {
        //#region Account Controller
        public static readonly UserId = 'UserId';
        public static readonly FullName = 'FullName';
        public static readonly MiddleName = 'MiddleName';
        public static readonly LastName = 'LastName';
        public static readonly MobilePhone = 'Phone';
        public static readonly EmailAddress = 'EmailAddress';
        public static readonly NameIdentifier = 'NameIdentifier';
        public static readonly BirthDate = 'BirthDate';
        public static readonly Gender = 'Gender';
        public static readonly Status = 'Status';
        public static readonly Active = 'Active';
        public static readonly ContactType = 'ContactType';
        //#endregion
    }
    //#endregion

    //#region Banner Items
    static BANNER_ITEMS = class {
        public static readonly AWARD_PRODUCT = 'AwardProduct';
        public static readonly TRAININGS = 'Training';
        public static readonly AWARDS = 'Award';
        public static readonly MARKETING_EXHIBITIONS = 'MarketingExhibition';
    }
    //#endregion

    //#region Available Service Type
    static TYPES = class {
        public static readonly AWARD = "Award";
        public static readonly PRODUCT_AWARD = "AwardProduct";
        public static readonly MARKETING_EXHEBITION = "MarketingExhibition";
        public static readonly TRAINING = "Training";
    }
    //#endregion

    //#region File Types
    static FILE_TYPES = class {
        public static readonly ID = "Id";
        public static readonly CR = "CR";
        public static readonly CERTIFICATE = "Certificate";
    }
    //#endregion
}
